import { FullStoryHeadTag } from './fullstory';
import { ZendeskScriptTag } from './zendesk';
import type { TrackingScript, TrackingContext } from './types';

const SCRIPTS = [FullStoryHeadTag, ZendeskScriptTag];

const tracking = {
  injectedScriptIds: new Set<string>(),

  load(ctx: TrackingContext) {
    SCRIPTS.forEach((script) => tracking._inject(script, ctx));

    if (ctx.authenticated) {
      tracking._setup(ctx);
    }
  },

  _setup(ctx: TrackingContext) {
    SCRIPTS.forEach((script: TrackingScript) => script.onAuth?.(ctx));
  },

  cleanup() {
    SCRIPTS.forEach((script: TrackingScript) => script.cleanup?.());
  },

  _inject(script: TrackingScript, ctx: TrackingContext) {
    if (tracking.injectedScriptIds.has(script.id)) {
      tracking._remove(script);
    }

    tracking.injectedScriptIds.add(script.id);
    script.inject(tracking._build(script, ctx), ctx);
  },

  _build(script: TrackingScript, ctx: TrackingContext) {
    const el = document.createElement(script.tag);
    el.id = script.id;
    if (script.type != null) {
      el.setAttribute('type', script.type);
    }
    if (script.content != null) {
      // nosemgrep: javascript.browser.security.insecure-document-method.insecure-document-method
      el.innerHTML = script.content;
    }
    if (script.src != null) {
      (el as any).src = script.src;
    }

    if (script.onScriptLoad != null) {
      el.addEventListener('load', () => {
        script.onScriptLoad!(ctx);
      });
    }

    return el;
  },

  _remove(script: TrackingScript) {
    script.cleanup?.();

    const el = document.getElementById(script.id);
    if (el != null) {
      el.parentNode?.removeChild(el);
    }
  },
};

export default tracking;
